export default {"src":"/_next/static/media/back-button.541d09be.svg","height":48,"width":48};